/**
 * Classe da coluna de conteúdo das molduras de página.
 *
 * Mora em arquivo próprio porque as duas molduras — `InternalLayout` (página
 * interna) e `SubHomeLayout` (sub-home) — usam exatamente a mesma coluna, e
 * porque a regra deixou de ser um ternário: agora há um sinal editorial
 * (`largura_total`, campo do behavior `ministerio.publico.federal.largura_pagina`)
 * por cima dos sinais estruturais.
 *
 * Ordem de decisão:
 *
 * 1. `larguraTotal` ligado -> `--full` (12/12). É escolha explícita do editor,
 *    então vence o cálculo de sidebar. Com `asideLeftSlot` presente a coluna já
 *    seria 12/12 de qualquer forma, e a classe fica inócua;
 * 2. sem sidebar -> `--centered` (8/12 centralizado), a coluna de leitura da
 *    RNF06, igual à da Notícia;
 * 3. com sidebar -> sem modificador: o texto já é estreitado pela lateral, e
 *    centralizar de novo o deixaria estreito duas vezes (ver `useHasSidebar`).
 *
 * O card da Área responsável espelha essa decisão de fora do grid, em
 * `components/UnidadeResponsavel/alignment.ts` — se a regra daqui mudar, a de
 * lá precisa acompanhar.
 */

const BASE = 'mpf-internal-view__content-area';

export const getContentAreaClassName = ({
  hasSidebar,
  larguraTotal,
}: {
  hasSidebar: boolean;
  larguraTotal?: boolean;
}): string => {
  if (larguraTotal) {
    return `${BASE} ${BASE}--full`;
  }

  return hasSidebar ? BASE : `${BASE} ${BASE}--centered`;
};

export default getContentAreaClassName;
